import * as React from 'react';
import {TProvider} from '../../../i18n/i18n';
import {stylesheet} from 'typestyle';
import {LightGreyColor} from '../../../styles/colors';

interface TableLimitPickerProps {
    lineLimitChanged: (newLimit: number) => void;
    lineLimit: number;
}

export function TableLimitPicker({lineLimitChanged, lineLimit}: TableLimitPickerProps) {
    return (
        <div>
            <TProvider>
                {(t) => (
                    <select
                        value={lineLimit}
                        className={limitPickerCss.limitSelect}
                        onChange={(e) => lineLimitChanged(parseInt(e.currentTarget.value, 10))}>
                        <option value={10}>{t('report:lines', {lineCount: 10})}</option>
                        <option value={20}>{t('report:lines', {lineCount: 20})}</option>
                        <option value={50}>{t('report:lines', {lineCount: 50})}</option>
                        <option value={100}>{t('report:lines', {lineCount: 100})}</option>
                    </select>
                )}
            </TProvider>
        </div>
    );
}

const limitPickerCss = stylesheet({
    limitSelect: {
        backgroundColor: 'transparent',
        borderColor: LightGreyColor,
        borderRight: 'none',
        height: 34,
        width: '100%',
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PaperSheetBlocks/TableLimitPicker.tsx